import { Helmet } from 'react-helmet-async';
// mantine
import { Loader, Container } from '@mantine/core';
// components
import Header from '@/components/Layout/components/Header';
import { useWidgetsContent } from '@/pages/Widgets/Widgets.hook';
import styles from '@/pages/Widgets/Widgets.module.css';

const Widgets = () => {
    const { content, isLoading } = useWidgetsContent();

    return (
        <>
            <Helmet>
                <title>NEWO - Widgets</title>
            </Helmet>
            <Header breadcrumbs={[{ label: 'Workflows' }]} />
            <Container fluid className={styles.container}>
                {isLoading ? (
                    <div className="flex items-center justify-center py-20">
                        <Loader />
                    </div>
                ) : undefined}

                <div className="relative w-full flex-1">{content}</div>
            </Container>
        </>
    );
};

export default Widgets;
